import { FC, PropsWithChildren, useState } from "react";
import { Button } from "./Button";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "./Dialog";

type ButtonWithConfirmProps = React.ComponentProps<typeof Button> & {
  confirmText: string;
};
export const ButtonWithConfirm: FC<
  PropsWithChildren<ButtonWithConfirmProps>
> = ({ confirmText, children, ...props }: ButtonWithConfirmProps) => {
  const { onClick: onConfirm, ...buttonProps } = props;
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const onCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  return (
    <>
      <Button
        {...buttonProps}
        onClick={(e) => {
          e.preventDefault();
          setIsConfirmDialogOpen(true);
        }}
      >
        {children}
      </Button>
      <Dialog open={isConfirmDialogOpen} onOpenChange={setIsConfirmDialogOpen}>
        <DialogContent>
          <DialogTitle>Confirmer l&apos;action</DialogTitle>
          <p className="text-sm">{confirmText}</p>
          <DialogFooter>
            <Button
              variant="ghost-blue"
              className="border-none outline-none"
              onClick={onCancel}
            >
              Annuler
            </Button>
            <Button
              variant="destructive-filled"
              onClick={(e) => {
                e.preventDefault();
                onConfirm?.(e);
                setIsConfirmDialogOpen(false);
              }}
            >
              Confirmer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
